import axios from "axios";
import "../config";

export default {
  async signUp(data) {
    return axios.post("/auth/signup", data);
  },
  async logIn(data) {
    return axios.post("/auth/login", data);
  },
  async duplicateLogin(data) {
    return axios.post("/auth/duplicate-login", data);
  },
  async recoverPassword(data) {
    return axios.post("/auth/send-password-reset-link", data);
  },
  async updatePasswordAndLogIn(data) {
    return axios.post("/auth/update-password", data);
  },
  async logOut() {
    return axios.get("auth/logout");
  },
  async updatePassword(data) {
    return axios.put("/auth/update-password", data);
  }
};
